export const parseADORepository = (repository: string) => {
	if (!repository)
		return { adoOrganization: '', adoProjectName: '', adoRepository: '' };
	const [adoOrganization, adoProjectName, adoRepository] =
		repository.split('/');
	return { adoOrganization, adoProjectName, adoRepository };
};
